import { SimpleDialog } from 'components';
import { Grid, Button } from '@mui/material';
import { OffilneReportMessage } from 'utility/TextMessages';
const ExportPodSpace = (props) => {
  const { isOpenExportDG, setIsOpenExportDG } = props;
  return (
    <SimpleDialog fullWidth maxWidth="sm" open={isOpenExportDG} title="درخواست فایل خروجی">
      <Grid container style={{ textAlign: 'justify' }}>
        <div>
          {OffilneReportMessage}
        </div>
      </Grid>
      <Grid style={{ display: 'flex', marginTop: '16px', flexDirection:'row-reverse' }}>
        <Button
          variant="contained"
          onClick={() => setIsOpenExportDG(false)}
        >
          بستن
        </Button>
      </Grid>
    </SimpleDialog>
  );
};

export default ExportPodSpace;
